// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { 
  getFirestore, 
  connectFirestoreEmulator, 
  enableIndexedDbPersistence,
  CACHE_SIZE_UNLIMITED
} from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
// Import analytics dynamically - not needed for initial load
// Do NOT initialize analytics immediately

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDA4IMML3tiNdaW1idS6iduWKYoY3j-RBQ",
  authDomain: "aihazardlog-a2b37.firebaseapp.com",
  projectId: "aihazardlog-a2b37",
  storageBucket: "aihazardlog-a2b37.appspot.com",
  messagingSenderId: "101982605774",
  appId: "1:101982605774:web:c84cd7d6413942d4fb9b9f",
  measurementId: "G-SJ7MKDNQW5",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and Firestore
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Lazy load analytics - will only be initialized when needed
let analyticsInstance = null;
export const getAnalyticsInstance = async () => {
  if (!analyticsInstance) {
    try {
      // Dynamic import to prevent loading during initial page load
      const { getAnalytics } = await import("firebase/analytics");
      analyticsInstance = getAnalytics(app);
    } catch (error) {
      console.error("Analytics failed to load:", error);
      // Return a mock analytics object with no-op methods
      analyticsInstance = { logEvent: () => {} };
    }
  }
  return analyticsInstance;
};

// Export a placeholder that gets replaced with real analytics when used
export const analytics = {
  app: app,
  async logEvent(...args) {
    const realAnalytics = await getAnalyticsInstance();
    const { logEvent } = await import("firebase/analytics");
    return logEvent(realAnalytics, ...args);
  }
};

// Set up emulators for local development
if (process.env.REACT_APP_USE_EMULATORS === "true") {
  connectFirestoreEmulator(db, "localhost", 8080);
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFunctionsEmulator(functions, "localhost", 5001);
}

// Enable offline persistence with a large cache size
// This helps with the "client is offline" errors
enableIndexedDbPersistence(db, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED
}).catch((err) => {
  console.warn("Firestore persistence failed to enable:", err.code);
});
